module.exports = __webpack_public_path__ + "static/media/4.7ef7280e.jpg";